module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hr', {
    staticClass: "mu-divider",
    class: {
      'inset': _vm.inset, 'shallow-inset': _vm.shallowInset
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aadff206"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/divider/divider.vue
// module id = 469
// module chunks = 1